require('./stylesheet/style.scss');
/**
 *  Module
 *
 * Description
 */
angular.module('pages.mycards', [])

.config(config);

config.$inject = ['$stateProvider'];

function config($stateProvider) {

    $stateProvider
        .state('pages.mycards', {
            url: 'mycards',
            template: require('./templates/index.html'),
            controller: require('./controllers/mycards.controller'),
            data: {
                restricted: true,
                iframe: false,
                breadcrumbs: 'MENU.CARDS'
            },
            params: {
                masterpassStatus: null,
                newUser: false,
                addMPCard: false,
                authMP: false,
                otp: false
            },
            pageTrack: '/myCards'
        })
}

module.exports = 'pages.mycards';



/*****************
 ** WEBPACK FOOTER
 ** ./app/pages/myCards/index.js
 ** module id = 273
 ** module chunks = 1
 **/